var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center"},[_c('span',{staticClass:"body-2"},[_vm._v("ERROR")]),_c('br'),_vm._v("\nContact support for help.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }